import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'scheduleSummary',
})
export class ScheduleSummaryPipe implements PipeTransform {
  transform(schedule: any): string {
    return `${this.getScheduleSummary(schedule)}`;
  }

  private getScheduleSummary(schedule: any): string {
    let text = '';
    switch (schedule.frequency) {
      case 'every_15_minutes':
        text = `Every 15 minutes at ${this.minuteSummaryDisplay(schedule.minute)}`;
        break;
      case 'every_30_minutes':
        text = `Every 30 minutes at ${this.minuteSummaryDisplay(schedule.minute)}`;
        break;
      case 'hourly':
        text = `Hourly at ${this.minuteSummaryDisplay(schedule.minute)}`;
        break;
      case 'daily':
        text = `Daily at ${this.hourDisplay(schedule)}:${this.minuteDisplay(schedule)} ${this.amOrPm(schedule)} ${
          schedule.timeZone
        }`;
        break;
      case 'weekly':
        text = `${this.checkForWeekday(schedule)} at ${this.hourDisplay(schedule)}:${this.minuteDisplay(
          schedule
        )} ${this.amOrPm(schedule)} ${schedule.timeZone}`;
        break;
      case 'monthly':
        text = `Every ${schedule.dayOfMonth} at ${this.hourDisplay(schedule)}:${this.minuteDisplay(
          schedule
        )} ${this.amOrPm(schedule)} ${schedule.timeZone}`;
        break;
    }
    return text;
  }

  private checkForWeekday(schedule: any) {
    if (schedule.frequency === 'weekly' && schedule.dayOfWeek === 'Monday,Tuesday,Wednesday,Thursday,Friday') {
      return 'Monday-Friday';
    } else {
      return schedule.dayOfWeek;
    }
  }

  private minuteSummaryDisplay(minute: number) {
    if (minute === 0) {
      return 'the top of the hour';
    } else {
      return minute + ' minutes past the hour';
    }
  }

  private hourDisplay(schedule: any) {
    const militaryTimeDiff = 12;
    switch (true) {
      case schedule.hour > 12:
        return schedule.hour - militaryTimeDiff;
      case schedule.hour === 0:
        return 12;
      default:
        return schedule.hour;
    }
  }

  private minuteDisplay(schedule: any) {
    switch (true) {
      case schedule.minute < 10:
        return `0${schedule.minute}`;
      default:
        return schedule.minute;
    }
  }

  private amOrPm(schedule: any) {
    return schedule.hour > 11 ? 'pm' : 'am';
  }
}
